import React, { FC, memo } from 'react'
import s from './BottomFixedContent.module.sass'
import { useAppSelector } from '@app/model/store'
import { RestItemPageFormat } from '@widgets/Common/BottomFixedContent/components/RestItemPageFormat'
import { DefaultPageFormat } from '@widgets/Common/BottomFixedContent/components/DefaultPageFormat'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'

const BottomFixedContent: FC = () => {
  const currentPage = useAppSelector((store) => store.global.currentPage)
  const mapOpened = useAppSelector((store) => store.features.map.active)
  const enabledGigachat =
    !mapOpened && !['owner_marketing', 'owner_booking', 'owner_landing_form', 'owner_landing'].includes(currentPage)
  const getComponent = () => {
    switch (currentPage) {
      case 'rest_item':
        return <RestItemPageFormat />
      default:
        return <DefaultPageFormat enabledGigachat={enabledGigachat} />
    }
  }

  return (
    <ErrorBoundary>
      <div className={s.wrapper}>{getComponent()}</div>
    </ErrorBoundary>
  )
}

export default memo(BottomFixedContent)
